import { createContext } from "react";

// Create the theme context
export const ThemeContext = createContext();
